module.exports = __webpack_public_path__ + "static/img/i53.55859536.png";